// @ts-nocheck
import { getEnabledList } from '#/apis/feedbackLetter.js';

export const PT_MENU_CATEGORIES = [
	{ href: '/letter_list', task: '피드백레터' },
	{ href: '/summary_list', task: '요약,질문' },
	{ href: '/docs_detection', task: '서류 검출' },
	{ href: '/docs_list', task: '서류' }
];

export function normalizeSettingIds(settingIds) {
	if (!Array.isArray(settingIds)) return [];
	return settingIds
		.map((id) => {
			if (typeof id === 'string') return id;
			if (id && typeof id === 'object' && '_id' in id) return String(id._id);
			return id == null ? '' : String(id);
		})
		.filter(Boolean);
}

/**
 * @param {any[] | undefined} settingIds
 * @returns {Promise<boolean[]>}
 */
export async function getPTMenuAccess(settingIds) {
	const allowedSettingIds = normalizeSettingIds(settingIds);
	if (allowedSettingIds.length === 0) {
		return PT_MENU_CATEGORIES.map(() => false);
	}

	const results = await Promise.all(
		PT_MENU_CATEGORIES.map((category) => getEnabledList(category.task).catch(() => ({ list: [] })))
	);

	return results.map((res) =>
		(res?.list ?? []).some((task) => allowedSettingIds.includes(String(task._id)))
	);
}

/**
 * @param {any[] | undefined} settingIds
 * @returns {Promise<string>}
 */
export async function getPTDefaultRoute(settingIds) {
	const access = await getPTMenuAccess(settingIds);
	const idx = access.findIndex(Boolean);
	return idx === -1 ? '/letter_list' : PT_MENU_CATEGORIES[idx].href;
}
